import './App.css';
import React, { useState, useEffect } from 'react';
import Question from './Question';

import MountaineeringImg from './img/g1.webp';
import ForestImg from './img/g2.webp';
import FamilyDinnerImg from './img/g3.webp';

var mobile = require('is-mobile');

const DATA = [
  {
    key: "introduction",
    type: "message",
    title: "מתחילים!",
    message: `בשאלון הבא, אתם נדרשים לענות מבלי להסתבך, כל שאלה אמורה להיענות תוך דקה / 2 דקות. תחשבו פשוט : "במידה והייתי נמצא/ת בסיטואציה זאת, מה היית ההחלטה שלי".`,
    nextBtnTxt: "המשך"
  },
  {
    key: "gender",
    type: "close_question",
    question: `מה המין שלך?`,
    options: [
      {
        "txt": "זכר",
        "key": "male"
      },
      {
        "txt": `נקבה`,
        "key": "female"
      },
      {
        "txt": "אחר",
        "key": "other"
      }
    ]
  },
  {
    key: "age",
    type: "close_question",
    question: `מה הגיל שלך?`,
    options: [
      {
        "txt": "פחות מ20",
        "key": "0-20"
      },
      {
        "txt": `בין 20 ל35`,
        "key": "20-35"
      },
      {
        "txt": "בין 35 ל50",
        "key": "35-50"
      },
      {
        "txt": "50 ומעלה",
        "key": "50-120"
      }
    ]
  },
  {
    key: "education",
    type: "close_question",
    question: `מה היא השכלתך?`,
    options: [
      {
        "txt": "תיכונית",
        "key": "basic"
      },
      {
        "txt": `תואר ראשון`,
        "key": "BA"
      },
      {
        "txt": "תואר שני ומעלה",
        "key": "MA+"
      }
    ]
  },
  {
    key: "finance_knowledge",
    type: "close_question",
    question: `מה מידת ההשכלה הפיננסית שלך?`,
    options: [
      {
        "txt": "ידע רב",
        "key": "high"
      },
      {
        "txt": `ידע מועט`,
        "key": "low"
      },
      {
        "txt": "חסר כל השכלה פיננסית",
        "key": "none"
      }
    ]
  },
  {
    key: "investment_900",
    type: "close_question",
    question: `קיבלת 900,000 ש"ח בירושה, מה היית עושה עם הכסף בין אפשרויות אלו?`,
    options: [
      {
        "txt": "להפקיד לקופת גמל להשקעה",
        "key": "kupat_gemel"
      },
      {
        "txt": `לרכוש נדלן בחו"ל`,
        "key": "real_eastate_aboard"
      },
      {
        "txt": "לסחור בבורסה דרך השקעות או באופן עצמאי",
        "key": "stock_market"
      }
    ]
  },
  {
    key: "pension",
    type: "close_question",
    question: `האם היית רוצה להפקיד לפנסיה עוד 3% מהמשכורת החודשית שלך?`,
    options: [
      {
        "txt": "כן",
        "key": "yes"
      },
      {
        "txt": "לא",
        "key": "no"
      },
      {
        "txt": "מעדיף להשקיע את זה במקום אחר",
        "key": "other_place"
      }
    ]
  },
  {
    key: "investment_startegy",
    type: "close_question",
    question: `סוכן מגיע לעבודה שלך ומציע לך שתי אפשרויות חיסכון, מה תעדיף?`,
    submit: true,
    options: [
      {
        "txt": "קרן כספית עם ריבית קבועה",
        "key": "constant_intresrt"
      },
      {
        "txt": "השקעה במניות בבורסה",
        "key": "stock_market"
      }
    ]
  },
  {
    key: "end",
    type: "message",
    title: "תודה רבה!",
    message: `כל הכבוד על המענה לשאלון!`,
    hideBack: true
  },
]



function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}

function assignRandomGroup() {
  const groups = Object.keys(groupToImg);
  return groups[Math.floor(Math.random() * groups.length)];
}

const groupToImg = {
  Mountaineering: MountaineeringImg,
  Forest: ForestImg,
  FamilyDinner: FamilyDinnerImg
}

function getRandomValue(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const result = {
  surveyId: 'BE-v0.9',
  ref: window.location.hash,
  uid: generateUUID(),
  group: assignRandomGroup()
}

const timeing = {
  0: Date.now()
}

// console.log(result)

function SubmitResult(cb) {
  result["time_to_fill"] = "" + (Date.now() - timeing[0]) / 1000
  fetch('https://ulr90ptyr5.execute-api.il-central-1.amazonaws.com/default/result-submiter', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(result)
  })
  .then(response => response.json())
  .then(data => {
      console.log('Success:', data);
      cb && cb()
  })
  .catch((error) => {
      console.error('Error:', error);
      alert("בעייה בתקשורת עם השרת")
  });
}

function App() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(1);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(Math.max(loading - 1, 0))
    }, 2000); 
    return () => clearTimeout(timer);
  }, []); 

  global.onAns = (k, v, isPartial) => {
    result[currentIndex + '_' + k] = v
    if(!isPartial) {
      handleNavigate('next')
      console.log(JSON.stringify(result))
    }
  }
  const handleNavigate = (direction) => {
    if (direction === 'next' && currentIndex < DATA.length - 1) {
      result[currentIndex + '_' + DATA[currentIndex].key + "_timeing"] = "" + (Date.now() - timeing[currentIndex]) / 1000
      setLoading(loading + 1)
      if(DATA[currentIndex].submit){
        SubmitResult(() => {
          setLoading(Math.max(loading - 1, 0))
          setCurrentIndex(currentIndex + 1);
        })
      } else {
        setTimeout(() => {
          setLoading(Math.max(loading - 1, 0))
          timeing[currentIndex + 1] =  Date.now();
          setCurrentIndex(currentIndex + 1);
        },  getRandomValue(1500, 2500))
      }
      
    } else if (direction === 'prev' && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className={mobile() ? "AppM" : "App"}>
      <div className="cellphone">
        <Question 
          loading={loading !== 0}
          img={groupToImg[result.group]}
          data={DATA[currentIndex]} 
          onNavigate={handleNavigate} 
          currentIndex={currentIndex} 
          totalQuestions={DATA.length} 
        />
      </div>
    </div>
  );
}

export default App;
